import { SentenceGradingFeedback } from '../types/sentence-grading-feedback.types';

export const DEFAULT_SENTENCE_GRADING_FEEDBACK = SentenceGradingFeedback.DELAYED as SentenceGradingFeedback;
